import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';

const Footer: React.FC = () => {
  return (
    <DefaultFooter
      style={{
        background: 'none',
      }}
      copyright="广西中满体育服务有限责任公司版权所有"
      links={[]}
    />
  );
};

export default Footer;
